<article class="form-wrapper">
  <header class="form-header">{{"SEND_VITALITY_SCAN" | translate}}</header>
  <form class="new-client-form" [formGroup]="newQuestionnaireForm" (ngSubmit)="onSubmit()">
    <ngx-intl-tel-input
      class="phone-number"
      formControlName="phoneNumber"
      [preferredCountries]="[CountryISO.Netherlands, CountryISO.Germany]"
      [separateDialCode]="true"
      [ngClass]="{'invalid-field': (!newQuestionnaireForm.controls.phoneNumber.valid && newQuestionnaireForm.controls.phoneNumber.touched) || (formSubmitted && !newQuestionnaireForm.controls.phoneNumber.valid)}">
    </ngx-intl-tel-input>
    <p *ngIf="newQuestionnaireForm.get('phoneNumber')!.invalid && formSubmitted === true" class="warning">
      {{'ENTER_VALID_MOBILE_PHONE_NUMBER' | translate}}
    </p>

    <input
      type="text"
      class="first-name"
      formControlName="firstName"
      [placeholder]="'FIRST_NAME' | translate"
      [ngClass]="{'invalid-field': (!newQuestionnaireForm.controls.firstName.valid && newQuestionnaireForm.controls.firstName.touched) || (formSubmitted && !newQuestionnaireForm.controls.firstName.valid)}" />
    <p *ngIf="newQuestionnaireForm.get('firstName')!.invalid && formSubmitted === true" class="warning">
      {{'ENTER_A_FIRST_NAME' | translate}}
    </p>

    <input
      type="text"
      class="last-name"
      formControlName="lastName"
      [placeholder]="'LAST_NAME' | translate"
      [ngClass]="{'invalid-field': (!newQuestionnaireForm.controls.lastName.valid && newQuestionnaireForm.controls.lastName.touched) || (formSubmitted && !newQuestionnaireForm.controls.lastName.valid)}" />
    <p *ngIf="newQuestionnaireForm.get('lastName')!.invalid && formSubmitted === true" class="warning">
      {{'ENTER_A_LAST_NAME' | translate}}
    </p>

    <button class="submit">{{'SEND' | translate}}</button>
  </form>
</article>
